import { skipToken } from '@reduxjs/toolkit/query';
import useAuth from 'hooks/useAuth.ts';
import { useGetEmployeeByIdQuery } from 'store/api/employees';

export const useCurrentEmployee = () => {
    const { user } = useAuth();
    return useGetEmployeeByIdQuery(user?.id?.toString() ?? skipToken);
};
